// import { MOCK_FLIGHT_WITH_OVERLAY } from './flights';
import { MOCK_FLIGHT_WITHOUT_OVERLAY, MOCK_FLIGHT_WITHOUT_OVERLAY2 } from './flights';

import type { ItineraryProduct, Rate, Supplier } from '../types/products';

export const MOCK_RATE: Rate = {
  type: 'unit',
  amount: 100,
};

export const MOCK_SUPPLIER: Supplier = {
  name: 'Camillas Hus',
  location: 'Oslo',
};

export const MOCK_SUPPLIER_TWO: Supplier = {
  name: 'Scandic Sorlandet',
  location: 'Kristiansand',
};

export const MOCK_SUPPLIER_THREE: Supplier = {
  location: 'Nicestreet 12, 1234AX Funchal',
  name: 'Supplier Z',
};

// ////////////////// ACCOMMODATIONS ////////////////////
// ////////////////// EXTRA ROOMS ////////////////////
export const MOCK_ROOM_STANDARD: ItineraryProduct = {
  id: 1,
  name: 'Standard Room',
  type: 'accommodation',
  nameForClient: 'Standard Room',
  startDate: '2021-09-01',
  endDate: '2021-09-02',
  sellAmount: 1000,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: false,
  productFacilities: ['wifi', 'kitchen', 'balcony', 'jacuzzi'],
  Content: [
    {
      type: 'main',
      paragraph:
        'Paulo heeft wat ons betreft de beste appartementen van de Funchal. De villa is een klein complex met in ' +
        'totaal negen appartementen, direct gelegen aan het strand. De appartementen kijken uit op de pier van ' +
        'Santa Maria en voor de villa staan prachtige palmbomen. ',
      RichContent: [
        {
          id: '1',
          type: 'image',
          path: 'https://balkonhekwerk.net/wp-content/uploads/2023/12/balkon-opleuken-meubels-1.jpg',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://balkonhekwerk.net/wp-content/uploads/2023/12/balkon-opleuken-meubels-1.jpg',
        },
      ],
    },
  ],
  startTime: '12:00',
  endTime: '12:00',
};

export const MOCK_ROOM_DELUXE: ItineraryProduct = {
  id: 2,
  name: 'Luxurious room',
  type: 'accommodation',
  nameForClient: 'Luxurious room',
  startDate: '2025-05-01',
  endDate: '2025-05-05',
  sellAmount: 1000,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: false,
  productFacilities: ['wifi', 'kitchen', 'balcony', 'jacuzzi'],
  Content: [
    {
      type: 'main',
      paragraph:
        '--- content 1.2 nodig --- Paulo heeft wat ons betreft de beste appartementen van de Funchal. ' +
        'De villa is een klein complex met in totaal negen appartementen, direct gelegen aan het strand. ' +
        'De appartementen kijken uit op de pier van Santa Maria en voor de villa staan prachtige palmbomen. ',
      RichContent: [
        {
          id: '3',
          type: 'image',
          subType: 'header',
          path: 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0a/46/b8/9e/entrance.jpg?w=700&h=-1&s=1',
        },
        {
          id: '4',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/gps-cs-s/AB5caB8zeJuW9ow_F-MFtxrAeJU4wikHSnHuzN3GjyNVgCgq39Cb1fDTambm_44U-j_w9qUjFbSZdi2JUufXcS9v13rFbPEJtLmn_t7PUbgmv0yevd443A2USmCZaZJl0TqgDzmPfQSbow=w243-h244-n-k-no-nu',
        },
        {
          id: '5',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/gps-cs-s/AB5caB8zeJuW9ow_F-MFtxrAeJU4wikHSnHuzN3GjyNVgCgq39Cb1fDTambm_44U-j_w9qUjFbSZdi2JUufXcS9v13rFbPEJtLmn_t7PUbgmv0yevd443A2USmCZaZJl0TqgDzmPfQSbow=w243-h244-n-k-no-nu',
        },
        // {
        //   id: '6',
        //   type: 'image',
        //   path: 'https://lh3.googleusercontent.com/gps-cs-s/AB5caB8zeJuW9ow_F-MFtxrAeJU4wikHSnHuzN3GjyNVgCgq39Cb1fDTambm_44U-j_w9qUjFbSZdi2JUufXcS9v13rFbPEJtLmn_t7PUbgmv0yevd443A2USmCZaZJl0TqgDzmPfQSbow=w243-h244-n-k-no-nu',
        // },
        // {
        //   id: '7',
        //   type: 'image',
        //   path: 'https://lh3.googleusercontent.com/gps-cs-s/AB5caB8zeJuW9ow_F-MFtxrAeJU4wikHSnHuzN3GjyNVgCgq39Cb1fDTambm_44U-j_w9qUjFbSZdi2JUufXcS9v13rFbPEJtLmn_t7PUbgmv0yevd443A2USmCZaZJl0TqgDzmPfQSbow=w243-h244-n-k-no-nu',
        // },
      ],
    },
  ],
  startTime: '13:00',
  endTime: '12:00',
};

export const MOCK_ROOM_DELUXE2: ItineraryProduct = {
  id: 3,
  name: 'Penthouse Suite',
  type: 'accommodation',
  nameForClient: 'Penthouse Suite',
  startDate: '2025-05-05',
  endDate: '2025-05-09',
  sellAmount: 1000,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: false,
  productFacilities: ['wifi', 'kitchen', 'balcony', 'jacuzzi'],
  Content: [
    {
      type: 'main',
      paragraph:
        '--- content 2.2 nodig --- Paulo heeft wat ons betreft de beste appartementen van de Funchal. ' +
        'De villa is een klein complex met in totaal negen appartementen, direct gelegen aan het strand. ' +
        'De appartementen kijken uit op de pier van Santa Maria en voor de villa staan prachtige palmbomen. ',
      RichContent: [
        {
          id: '3',
          type: 'image',
          subType: 'header',
          path: 'https://lh3.googleusercontent.com/proxy/NnTqg27IMlTQ4s1l9bwVdY-ThRhouWtaLZs1H41KI5ZkhcPdfUHwR99yCJuYHT43uNiS3fbR54MgDV5XgdPOpqI0MjRseCvldgakNdug9v3SfuqlcoAbL_OLQD6t4g9zdQAAAv6c3bQ2TFC4vgTYmgqsQW4JEw=s680-w680-h510',
        },
        {
          id: '4',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/btQKBrehuMrLpzkHK4jP9uNCPN1_KvMpCTOJoW5NfNJGPLPqxTRbSL2VOU2s-o9zMuaUyE5xzonobylUuit2RZTClL05KPMXMx2OLoXFMO4aGRA5o-L6F5F-O27Q94eCKioKRq8xFxYF1P3nhZgj3ojxnbgk2w=s680-w680-h510',
        },
        {
          id: '5',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/btQKBrehuMrLpzkHK4jP9uNCPN1_KvMpCTOJoW5NfNJGPLPqxTRbSL2VOU2s-o9zMuaUyE5xzonobylUuit2RZTClL05KPMXMx2OLoXFMO4aGRA5o-L6F5F-O27Q94eCKioKRq8xFxYF1P3nhZgj3ojxnbgk2w=s680-w680-h510',
        },
        // {
        //   id: '6',
        //   type: 'image',
        //   path: 'https://lh3.googleusercontent.com/gps-cs-s/AB5caB8zeJuW9ow_F-MFtxrAeJU4wikHSnHuzN3GjyNVgCgq39Cb1fDTambm_44U-j_w9qUjFbSZdi2JUufXcS9v13rFbPEJtLmn_t7PUbgmv0yevd443A2USmCZaZJl0TqgDzmPfQSbow=w243-h244-n-k-no-nu',
        // },
        // {
        //   id: '7',
        //   type: 'image',
        //   path: 'https://lh3.googleusercontent.com/gps-cs-s/AB5caB8zeJuW9ow_F-MFtxrAeJU4wikHSnHuzN3GjyNVgCgq39Cb1fDTambm_44U-j_w9qUjFbSZdi2JUufXcS9v13rFbPEJtLmn_t7PUbgmv0yevd443A2USmCZaZJl0TqgDzmPfQSbow=w243-h244-n-k-no-nu',
        // },
      ],
    },
  ],
  startTime: '12:00',
  endTime: '12:00',
};

export const MOCK_ROOM_DELUXE3: ItineraryProduct = {
  id: 4,
  name: 'Luxury room',
  type: 'accommodation',
  nameForClient: 'Luxury room',
  startDate: '2025-05-09',
  endDate: '2025-05-15',
  sellAmount: 840,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: false,
  productFacilities: ['wifi', 'kitchen', 'balcony', 'jacuzzi'],
  Content: [
    {
      type: 'main',
      paragraph:
        '--- content 3.2 nodig --- Paulo heeft wat ons betreft de beste appartementen van de Funchal. ' +
        'De villa is een klein complex met in totaal negen appartementen, direct gelegen aan het strand. ' +
        'De appartementen kijken uit op de pier van Santa Maria en voor de villa staan prachtige palmbomen. ',
      RichContent: [
        {
          id: '3',
          type: 'image',
          subType: 'header',
          path: 'https://lh3.googleusercontent.com/proxy/T3_y1qLc5sZcvlsj07WAEj9FdkwbMrddxK_QFXaOUembytaOKu7NYnQFVTconbH7WquOMaJS1oOpHzrFQfjrkACVenSJ_ipunwEnxOT9i7epZMFZGu_niXudS-8H7vaenZVy-5hZ5oK_H0o5rWzfvBF4P2i__e0=s680-w680-h510',
        },
        {
          id: '4',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/p/AF1QipO991GDzdUbD9F8QSJm3QB3_7BaWIardnsV3z3r=s680-w680-h510',
        },
        {
          id: '5',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/p/AF1QipO991GDzdUbD9F8QSJm3QB3_7BaWIardnsV3z3r=s680-w680-h510',
        },
        // {
        //   id: '6',
        //   type: 'image',
        //   path: 'https://lh3.googleusercontent.com/gps-cs-s/AB5caB8zeJuW9ow_F-MFtxrAeJU4wikHSnHuzN3GjyNVgCgq39Cb1fDTambm_44U-j_w9qUjFbSZdi2JUufXcS9v13rFbPEJtLmn_t7PUbgmv0yevd443A2USmCZaZJl0TqgDzmPfQSbow=w243-h244-n-k-no-nu',
        // },
        // {
        //   id: '7',
        //   type: 'image',
        //   path: 'https://lh3.googleusercontent.com/gps-cs-s/AB5caB8zeJuW9ow_F-MFtxrAeJU4wikHSnHuzN3GjyNVgCgq39Cb1fDTambm_44U-j_w9qUjFbSZdi2JUufXcS9v13rFbPEJtLmn_t7PUbgmv0yevd443A2USmCZaZJl0TqgDzmPfQSbow=w243-h244-n-k-no-nu',
        // },
      ],
    },
  ],
  startTime: '12:00',
  endTime: '12:00',
};

export const MOCK_ROOM_SUITE: ItineraryProduct = {
  id: 3,
  name: 'Suite Room',
  type: 'accommodation',
  nameForClient: 'Suite Room',
  startDate: '2021-09-01',
  endDate: '2021-09-03',
  sellAmount: 1000,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER_THREE,
  selected: false,
  productFacilities: ['wifi', 'kitchen', 'balcony', 'jacuzzi'],
  Content: [
    {
      type: 'main',

      paragraph:
        'Paulo heeft wat ons betreft de beste appartementen van de Funchal. ' +
        'De villa is een klein complex met in totaal negen appartementen, direct gelegen aan het strand. ' +
        'De appartementen kijken uit op de pier van Santa Maria en voor de villa staan prachtige palmbomen. ',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path:
            'https://s3-alpha-sig.figma.com/img/e421/0aff/1eb1298642333389a68a132983ddd2e9?Expires=1721606400&Key' +
            '-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=MG9FvLWFTh7r3om24W9404I7KxCAnlVmPWPdLHtXnBlgC4HxwEdDYJnYdwp' +
            'UoYzPXmpvmI2nyjER0AgXOPJXXlWglbutOZc-f9E84bSQYHD1XUoJpvIsseH2mFf0VHgH~RCFvy1ebNfmORDB8NGRS92U58RmBG' +
            'zYTkhoH9ft~nkd0xe8htfyw3zYYCM~yjag61bp90IvEaR85HHQIQ~t~hDoUuAF3qEYD6~HJBt~5kY-XRmq7dae~OIYOyGYoiekm' +
            '48vDStcgerc4EUgAlW9h8-eMj2l0z6XkQMXagcuyGmAazA1oeJgzK3MfMEVn-a5R3M8XtHLIUdt3jXL7b~snw__',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://s3-alpha-sig.figma.com/img/b522/a632/93d530b027f2e6dd4af2c6940065d868?Expires=1721606400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Fc93gDFYVmuWGgvo2BLKc~F8lU3K-MGN~Gho1yj2JSupGryRW95JNz8ydMdPEDxcCD2MylHIv4KChFzzEuGBsV1X80kucUagf-tV1VBwz4k1JexN~j9kvNe7C0zzDCyLU0Pf~QmdYyuPy56rrBOCyreohftNZSg8pW6PTZ-wnNnhy9LSvpdHT3vnGQH7o8BbP~4wZx2fCMMEg4rV4bVfy5uGKmEWZYVg4c2f2uZb-9dmzQuB6a8Cx6nn99ZCNb3MoWzm8Yi1j8B3b12d75bvChnosKUFT0VskV4qwTud3Lqha7Cd2VFHEiSWKu5jV-LmwBaoNdl93S0gZW8hYOD~ug__',
        },
        {
          id: '3',
          type: 'image',
          path: 'https://s3-alpha-sig.figma.com/img/45e7/4ced/3248b01d6f2bfe0a776e4a135f2eb741?Expires=1721606400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=I~eQbeH9iCJ9N6VxkgSZNY1yBs0lcCl687VEAoeWi5UZgrz8zulXa1HyfrD5uhWyFov93GH2DnRYUc0jRYKsFvz-pYhk~769t3h7OdxLff73iwHRYNfsUHwgKNoBdYGdaYQT4K3PcOK64tQVk-3Jito7WoHrc4pgm5UZI-VtZX-gB~~efbfaLkJ~6-NlpTtLSbnKvDC4T6zPGXj9FRjxIpftA-rnl1ypqeRexqBA8TQUbLM8XAJFMITN9QiXLp4D4C3LOf50BaU4JluSDLvEd8BHI4qN0GT1yZs8gqUOuSqe052WfifFzhfjAA1xrVE3VtsnOwUAmxcHraHzz2A3LQ__',
        },
        {
          id: '4',
          type: 'image',
          path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
        },
        {
          id: '5',
          type: 'image',
          path: 'https://s3-alpha-sig.figma.com/img/404f/911a/9af40c285d4ba4bb143bb34cddba4603?Expires=1721606400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Z1zsVHikyMMSyhLXsZzwjIC7KCrXpEpgLsTSQ5QQ7hNdW3RZer8VEcJDMCOHQ2kUx~FZAqfxSIKHnW-2-RCRyUC4jUl81dkx-G9ftGVxTqgCifI3-G-h-0elFm0PAhkWk8cs60wb1Hdn5xCpkGXkNsYMGgOZj7U64LEJmkKwTSfhzv5JkAzok7gQ-CPtFnXmHkaApjKoUW0qcy1B2qZ4hZ~XkK79zcGn13VzJRAg2tQx~R5vjJ-NZrI5EmnM9fMGBh1CB2~O8Ph~CjzAwrdr0S9f4qH~~9OmitsWVGWcvWciHdyfnt~~a~eG7EPHWLowmbIPFopQ8q3Cvnam9~zLCw__',
        },
      ],
    },
  ],
  startTime: '12:00',
  endTime: '12:00',
};
// ////////////////// EXTRA ROOMS ////////////////////

export const MOCK_ITINERARY_ACCOMMODATION_PRODUCT: ItineraryProduct = {
  id: 1,
  name: 'junior suite room',
  carouselName: 'Camillas Hus',
  type: 'accommodation',
  nameForClient: 'junior suite room',
  startDate: '2025-05-01',
  startTime: '15:00',
  endDate: '2025-05-05',
  endTime: '11:00',
  sellAmount: 720,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: true,
  // alternate: [MOCK_ROOM_STANDARD, MOCK_ROOM_DELUXE],
  // alternate: [MOCK_ROOM_DELUXE],
  ItineraryProductOptions: [
    {
      name: 'Breakfast',
      type: 'mealplan',
      units: 2,
      surplus: 20,
      selected: false,
    },
  ],
  productFacilities: ['wifi', 'pool'],
  Content: [
    {
      type: 'main',
      header: 'You will stay at Camillas Hus',
      subHeader: 'Ruim appartement met zeezicht',
      paragraph:
        'Camillas Hus offers a unique stay in a spacious apartment with breathtaking sea views. Enjoy the ' +
        'tranquility and comfort of a fully furnished accommodation, equipped with all modern amenities such ' +
        'as free WiFi and a swimming pool. The villa is located right by the beach, surrounded by tropical palm ' +
        'trees, and within walking distance of Funchal’s lively promenade. Whether you’re relaxing on your private ' +
        'terrace or taking a refreshing dip in the pool, this is the perfect blend of luxury and nature. It’s the ' +
        'ideal base to explore the island and experience everything Madeira has to offer.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path: 'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0a/46/b8/9e/entrance.jpg?w=700&h=-1&s=1',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://lh5.googleusercontent.com/p/AF1QipOXQqUvu6xiAKKqRhr-6rTV6E3aMamYzxVmsLI8=w243-h174-n-k-no-nu',
        },
        {
          id: '3',
          type: 'image',
          path: 'https://lh5.googleusercontent.com/p/AF1QipOXQqUvu6xiAKKqRhr-6rTV6E3aMamYzxVmsLI8=w243-h174-n-k-no-nu',
        },
        {
          id: '4',
          type: 'image',
          path: 'https://lh5.googleusercontent.com/p/AF1QipOXQqUvu6xiAKKqRhr-6rTV6E3aMamYzxVmsLI8=w243-h174-n-k-no-nu',
        },
        {
          id: '5',
          type: 'image',
          path: 'https://lh5.googleusercontent.com/p/AF1QipOXQqUvu6xiAKKqRhr-6rTV6E3aMamYzxVmsLI8=w243-h174-n-k-no-nu',
        },
      ],
    },
  ],
};

export const MOCK_ITINERARY_ACCOMMODATION_PRODUCT2: ItineraryProduct = {
  id: 2,
  name: 'Standard Room',
  carouselName: 'Scandic Sorlandet',
  type: 'accommodation',
  nameForClient: 'Standard Room',
  startDate: '2025-05-05',
  startTime: '15:00',
  endDate: '2025-05-09',
  endTime: '11:00',
  sellAmount: 492,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: true,
  // alternate: [MOCK_ROOM_STANDARD, MOCK_ROOM_DELUXE],
  alternate: [MOCK_ROOM_DELUXE2],
  ItineraryProductOptions: [
    {
      name: 'Breakfast',
      type: 'mealplan',
      units: 2,
      surplus: 20,
      selected: false,
    },
  ],
  productFacilities: ['wifi', 'pool'],
  Content: [
    {
      type: 'main',
      header: 'You will stay at Scandic Sorlandet',
      subHeader: 'Ruim appartement met zeezicht',
      paragraph:
        'At Scandic Sørlandet, you will enjoy a comfortable stay in a spacious apartment with stunning sea ' +
        'views. The hotel offers a relaxing atmosphere with modern amenities such as free WiFi and a swimming ' +
        'pool. Conveniently located near the coastline, it provides easy access to beautiful beaches, scenic ' +
        'walking trails, and vibrant local attractions. Whether you start your day with a refreshing swim, ' +
        'explore the charming surroundings, or unwind in the cozy lounge area, this is the perfect place for a ' +
        'memorable stay. Experience the best of relaxation and adventure, all in one destination.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path: 'https://lh3.googleusercontent.com/proxy/NnTqg27IMlTQ4s1l9bwVdY-ThRhouWtaLZs1H41KI5ZkhcPdfUHwR99yCJuYHT43uNiS3fbR54MgDV5XgdPOpqI0MjRseCvldgakNdug9v3SfuqlcoAbL_OLQD6t4g9zdQAAAv6c3bQ2TFC4vgTYmgqsQW4JEw=s680-w680-h510',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/TK500DBcew4dDcmiy73gdNPb25wk_cbNRWUbGZzRXrMMz4toYwTpM14bB7CD0mqa2zm9SewixlGI8xsZv1D1Aq94BDstzrIWFoS_SrIpwDNnUZ5ElQ2UIxb3KDOY9UFxOeigJY8I9h9GTY7LCzWPiixXkUs5jw=s680-w680-h510',
        },
        {
          id: '3',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/TK500DBcew4dDcmiy73gdNPb25wk_cbNRWUbGZzRXrMMz4toYwTpM14bB7CD0mqa2zm9SewixlGI8xsZv1D1Aq94BDstzrIWFoS_SrIpwDNnUZ5ElQ2UIxb3KDOY9UFxOeigJY8I9h9GTY7LCzWPiixXkUs5jw=s680-w680-h510',
        },
        {
          id: '4',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/TK500DBcew4dDcmiy73gdNPb25wk_cbNRWUbGZzRXrMMz4toYwTpM14bB7CD0mqa2zm9SewixlGI8xsZv1D1Aq94BDstzrIWFoS_SrIpwDNnUZ5ElQ2UIxb3KDOY9UFxOeigJY8I9h9GTY7LCzWPiixXkUs5jw=s680-w680-h510',
        },
        {
          id: '5',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/TK500DBcew4dDcmiy73gdNPb25wk_cbNRWUbGZzRXrMMz4toYwTpM14bB7CD0mqa2zm9SewixlGI8xsZv1D1Aq94BDstzrIWFoS_SrIpwDNnUZ5ElQ2UIxb3KDOY9UFxOeigJY8I9h9GTY7LCzWPiixXkUs5jw=s680-w680-h510',
        },
      ],
    },
  ],
};

export const MOCK_ITINERARY_ACCOMMODATION_PRODUCT3: ItineraryProduct = {
  id: 3,
  name: 'Standard Room City Hostel Bergen',
  carouselName: 'City Hotel Bergen',
  type: 'accommodation',
  nameForClient: 'Standard Room City Hostel Bergen',
  startDate: '2025-05-09',
  startTime: '15:00',
  endDate: '2025-05-15',
  endTime: '11:00',
  sellAmount: 570,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: true,
  // alternate: [MOCK_ROOM_STANDARD, MOCK_ROOM_DELUXE],
  alternate: [MOCK_ROOM_DELUXE3],
  ItineraryProductOptions: [
    {
      name: 'Breakfast',
      type: 'mealplan',
      units: 2,
      surplus: 20,
      selected: false,
    },
  ],
  productFacilities: ['wifi', 'pool'],
  Content: [
    {
      type: 'main',
      header: 'You will stay at City Hotel Bergen',
      subHeader: 'Ruim appartement met zeezicht',
      paragraph:
        'City Hotel Bergen offers a welcoming and comfortable stay in the heart of the city, with spacious ' +
        'apartments and stunning sea views. Enjoy modern amenities such as free WiFi and a cozy lounge area, ' +
        'perfect for unwinding after a day of exploring. The hotel is ideally located near Bergen’s charming ' +
        'waterfront, bustling markets, and cultural hotspots. Whether you’re strolling through the historic ' +
        'Bryggen district, taking a scenic fjord tour, or simply relaxing in your well-equipped apartment, ' +
        'this hotel is the perfect base for your Norwegian adventure.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path: 'https://lh3.googleusercontent.com/proxy/T3_y1qLc5sZcvlsj07WAEj9FdkwbMrddxK_QFXaOUembytaOKu7NYnQFVTconbH7WquOMaJS1oOpHzrFQfjrkACVenSJ_ipunwEnxOT9i7epZMFZGu_niXudS-8H7vaenZVy-5hZ5oK_H0o5rWzfvBF4P2i__e0=s680-w680-h510',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/LhOpN42X73TkqmtoiOhur6lAonRrgv1kq5Emn3zIh9teZDiYOtcMmkVJgw2nkYBXd2hmT-sN8pe_cZ3aiM81jmu10QbRLO2BocE0DR_xAuiYpAGu3BEH05yrZ6aQYl7XJWT7WOc58Xj3dWzRt_Lx_oSWkrMtKQ=s680-w680-h510',
        },
        {
          id: '3',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/LhOpN42X73TkqmtoiOhur6lAonRrgv1kq5Emn3zIh9teZDiYOtcMmkVJgw2nkYBXd2hmT-sN8pe_cZ3aiM81jmu10QbRLO2BocE0DR_xAuiYpAGu3BEH05yrZ6aQYl7XJWT7WOc58Xj3dWzRt_Lx_oSWkrMtKQ=s680-w680-h510',
        },
        {
          id: '4',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/LhOpN42X73TkqmtoiOhur6lAonRrgv1kq5Emn3zIh9teZDiYOtcMmkVJgw2nkYBXd2hmT-sN8pe_cZ3aiM81jmu10QbRLO2BocE0DR_xAuiYpAGu3BEH05yrZ6aQYl7XJWT7WOc58Xj3dWzRt_Lx_oSWkrMtKQ=s680-w680-h510',
        },
        {
          id: '5',
          type: 'image',
          path: 'https://lh3.googleusercontent.com/proxy/LhOpN42X73TkqmtoiOhur6lAonRrgv1kq5Emn3zIh9teZDiYOtcMmkVJgw2nkYBXd2hmT-sN8pe_cZ3aiM81jmu10QbRLO2BocE0DR_xAuiYpAGu3BEH05yrZ6aQYl7XJWT7WOc58Xj3dWzRt_Lx_oSWkrMtKQ=s680-w680-h510',
        },
      ],
    },
  ],
};

export const MOCK_ITINERARY_ACCOMMODATION_PRODUCT_LOREM: ItineraryProduct = {
  id: 2,
  name: 'Driepersoonskamer',
  type: 'accommodation',
  nameForClient: 'Driepersoonskamer',
  startDate: '2021-09-01',
  endDate: '2021-09-03',
  sellAmount: 1000,
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER_THREE,
  selected: true,
  alternate: [MOCK_ROOM_SUITE],
  ItineraryProductOptions: [
    {
      name: 'Breakfast',
      type: 'mealplan',
      units: 2,
      surplus: 20,
      selected: true,
    },
  ],
  productFacilities: ['wifi', 'pool', 'restaurant', 'bar', 'parking'],
  Content: [
    {
      type: 'main',
      header: 'Lorem ipsum dolor sit amet',
      subHeader: 'Consectetur adipisicing elit',
      paragraph:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et' +
        ' dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ' +
        'ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu ' +
        'fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt ' +
        'mollit anim id est laborum.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path: 'hhttps://cf.bstatic.com/xdata/images/hotel/max1024x768/490710275.jpg?k=3b4a4dd6774952791cc51ea82f0397735b41f8557f97ea6a2846d6921b1f84e7&o=&hp=1',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
        },
        {
          id: '3',
          type: 'image',
          path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
        },
        {
          id: '4',
          type: 'image',
          path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
        },
        {
          id: '5',
          type: 'image',
          path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
        },
      ],
    },
  ],
  startTime: '12:00',
  endTime: '12:00',
};

// export const MOCK_ITINERARY_ACCOMMODATION_PRODUCT_UPGRADE: ItineraryProduct = {
//   id: 3,
//   name: 'Top kamer',
//   type: 'accommodation',
//   nameForClient: 'Top kamer',
//   startDate: '2021-09-01',
//   endDate: '2021-09-03',
//   sellAmount: 1000,
//   Rate: MOCK_RATE,
//   Supplier: MOCK_SUPPLIER_TWO,
//   selected: false,
//   ItineraryProductOptions: [
//     {
//       name: 'Breakfast',
//       type: 'mealplan',
//       units: 2,
//       surplus: 20,
//       selected: true,
//     },
//   ],
//   productFacilities: ['wifi', 'pool', 'restaurant', 'bar', 'parking'],
//   Content: [
//     {
//       type: 'main',
//       header: 'Je verblijft in de luxe villa van Paulo',
//       subHeader: 'Ruim appartement met zeezicht',
//       paragraph:
//         'Paulo heeft wat ons betreft de beste appartementen van de Funchal. ' +
//         'De villa is een klein complex met in totaal negen appartementen, direct gelegen aan het strand. ' +
//         'De appartementen kijken uit op de pier van Santa Maria en voor de villa staan prachtige palmbomen. ',
//       RichContent: [
//         {
//           id: '1',
//           type: 'image',
//           subType: 'header',
//           path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
//         },
//         {
//           id: '2',
//           type: 'image',
//           path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
//         },
//         {
//           id: '3',
//           type: 'image',
//           path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
//         },
//         {
//           id: '4',
//           type: 'image',
//           path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
//         },
//         {
//           id: '5',
//           type: 'image',
//           path: 'https://cf.bstatic.com/xdata/images/hotel/max500/488949220.jpg?k=6833e1dfd0867d3435050af3ab2a958935f1bf538b652181994c239976e5dec3&o=&hp=1',
//         },
//       ],
//     },
//   ],
//   startTime: '12:00',
//   endTime: '12:00',
// };
// ////////////////// ACCOMMODATIONS ////////////////////

export const MOCK_ITINERARY_RENTAL_CAR_PRODUCT: ItineraryProduct = {
  id: 4,
  name: 'Mercedes A class or similar',
  nameForClient: 'Mercedes A class or similar',
  type: 'carrental',
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  startDate: '2025-05-01',
  startTime: '10:00',
  endDate: '2025-05-15',
  endTime: '12:00',
  sellAmount: 300,
  productFacilities: ['handgeschakeld', 'benzine', '4 personen'],
  selected: true,
  Content: [
    {
      type: 'main',
      header: 'Ontdek het eiland',
      subHeader: 'Autohuur',
      paragraph:
        'Met de auto ontdek je de mooiste plekjes van het eiland. ' +
        'Rijd langs de kust en stop bij de vele uitzichtpunten. ' +
        'Bezoek de botanische tuinen en de levada’s. ' +
        'De auto is de ideale manier om het eiland te verkennen.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          path: 'image/car.jpg',
        },
      ],
    },
  ],
};

export const MOCK_ITINERARY_EXCURSION_PRODUCT: ItineraryProduct = {
  id: 5,
  name: 'Visit Holmenkollen and the Ski Museum',
  type: 'excursion',
  Rate: MOCK_RATE,
  Supplier: {
    name: 'Oslo Fun',
    location: 'Oslo',
  },
  startTime: '09:00:00',
  startDate: '2025-05-02',
  endTime: '13:00:00',
  endDate: '2025-05-02',
  sellAmount: 104.0,
  selected: true,
  Content: [
    {
      type: 'main',
      header: 'Visit Holmenkollen and the Ski Museum',
      subHeader: 'Ontdek de onderwaterwereld',
      paragraph:
        'Perched high above Oslo, Holmenkollen is more than just a ski jump—it’s a symbol of Norway’s ' +
        'rich skiing heritage and a must-visit destination for travelers seeking breathtaking views, history, ' +
        'and adventure.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path: 'https://hopon.no/wp-content/uploads/2024/02/hop-on-hop-off-sightseeing-tour-bus-oslo-attractions-holmenkollen.webp',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://hopon.no/wp-content/uploads/2024/02/hop-on-hop-off-sightseeing-tour-bus-oslo-attractions-holmenkollen.webp',
        },
      ],
    },
  ],
};

export const MOCK_ITINERARY_EXCURSION_PRODUCT_KRISTIANSAND: ItineraryProduct = {
  id: 53223,
  name: 'Explore Kristiansand and Dyreparken',
  type: 'excursion',
  Rate: MOCK_RATE,
  Supplier: {
    name: 'Norway adventures',
    location: 'Kristiansand',
  },
  startTime: '10:00:00',
  startDate: '2025-05-06',
  endTime: '16:00:00',
  endDate: '2025-05-06',
  sellAmount: 130.0,
  selected: true,
  Content: [
    {
      type: 'main',
      header: 'Explore Kristiansand and Dyreparken',
      subHeader: '',
      paragraph:
        'Nestled along Norway’s southern coast, Kristiansand is a charming seaside city known for its ' +
        'beautiful beaches, cultural scene, and family-friendly attractions. Whether you’re looking for ' +
        'relaxation, adventure, or wildlife encounters, Kristiansand has something for everyone.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path: 'https://assets.simpleviewcms.com/simpleview/image/fetch/c_limit,h_1200,q_75,w_1200/https://media.newmindmedia.com/TellUs/image/%3Ffile%3DEBEDC6F907D2CA1210275ADACE20C97D02F3B7AB.jpg%26dh%3D533%26dw%3D800%26cropX%3D0%26cropY%3D0%26cropH%3D3494%26cropW%3D5249%26t%3D4',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://hopon.no/wp-content/uploads/2024/02/hop-on-hop-off-sightseeing-tour-bus-oslo-attractions-holmenkollen.webp',
        },
      ],
    },
  ],
};

export const MOCK_ITINERARY_EXCURSION_PRODUCT_FJORD: ItineraryProduct = {
  id: 53223,
  name: 'Guided Trolltunga Hike',
  type: 'excursion',
  Rate: MOCK_RATE,
  Supplier: {
    name: 'Outdoor Bergen',
    location: 'Bergen',
  },
  startTime: '07:00:00',
  startDate: '2025-05-10',
  endTime: '19:00:00',
  endDate: '2025-05-10',
  sellAmount: 234.0,
  selected: true,
  Content: [
    {
      type: 'main',
      header: 'Guided Trolltunga Hike',
      subHeader: '',
      paragraph:
        'One of the most breathtaking and rewarding hikes in Norway, Trolltunga (the “Troll’s Tongue”) is a ' +
        'bucket-list adventure for nature lovers and thrill-seekers alike. Hanging 1,100 meters above sea ' +
        'level with panoramic views over the stunning Ringedalsvatnet Lake, Trolltunga is an unforgettable ' +
        'experience—especially when done with a professional guide.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path: 'https://cdn.prod.website-files.com/6754b383c9f0ce60f87bc673/67dab8f79433d23f380ab20b_image00004-Baard-Basberg-Trolltunga-Adventures.avif',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://hopon.no/wp-content/uploads/2024/02/hop-on-hop-off-sightseeing-tour-bus-oslo-attractions-holmenkollen.webp',
        },
      ],
    },
  ],
};
export const MOCK_ITINERARY_EXCURSION_PRODUCT_UNSELECTED: ItineraryProduct = {
  id: 6,
  name: 'Fjord Cruise to Nærøyfjord',
  type: 'excursion',
  Rate: MOCK_RATE,
  Supplier: {
    name: 'Outdoor Bergen',
    location: 'Bergen',
  },
  startTime: '09:00:00',
  startDate: '2025-05-12',
  endTime: '15:00:00',
  endDate: '2025-05-12',
  sellAmount: 234.0,
  selected: false,
  Content: [
    {
      type: 'main',
      header: 'Fjord Cruise to Nærøyfjord',
      subHeader: '',
      paragraph:
        'Embark on an unforgettable fjord cruise to Nærøyfjord, one of Norway’s most stunning and ' +
        'dramatic waterways. A UNESCO World Heritage Site, this narrow fjord is surrounded by towering mountains, ' +
        'cascading waterfalls, and charming villages that seem untouched by time.',
      RichContent: [
        {
          id: '1',
          type: 'image',
          subType: 'header',
          path: 'https://assets.simpleviewcms.com/simpleview/image/fetch/c_fill,h_1080,w_1920/f_jpg/q_65/https://media.newmindmedia.com/TellUs/image/%3Ffile%3D44FF31C9B3E21C869DEC3FFE7E3266C487B425B3.jpg&dh%3D433&dw%3D800&t%3D4',
        },
        {
          id: '2',
          type: 'image',
          path: 'https://s3-alpha-sig.figma.com/img/a8ad/3309/08175579ef59839e816a30f448284fc8?Expires=1723420800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=fqURuMsy6j7NG-v49OASOdwvT6qr3mgYC~I5rFnB7jcJ9tpv50KZPTFaY7~FSxtsoHVJ34-mUL2o5QYp~1BfPWR-gEiPeydaqOEaaWILr13qPVZmNw~aO5-n8cZva-2AE0khsozZbjX7DmD5oXnTKWFPMxhQehGyhfcF-9Z0RMjE5PanVQgCHd0Eaqf7sT4fmLKVdLUcKlr3ee30-SRAwkz-bGhyFH6NGdzYZWm2SsbZ4PBDrwb9FB31IPl~m1g7yXM4AdbDmDAYE2ITb2Vfl2RfnTq2yc3F8-PoOlJ7l-yzx~lcjUWm6SPKShERbeZEP9R4dvBc7VacYOW7OqnilA__',
        },
      ],
    },
  ],
};

export const MOCK_ITINERARY_FLIGHT_PRODUCT: ItineraryProduct = {
  id: 7,
  name: 'Vlucht',
  type: 'flight',
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: true,
  startDate: '2025-05-01',
  startTime: '09:00',
  endDate: '2025-05-01',
  endTime: '12:00',
  sellAmount: 100,
  Content: [],
  // flight: MOCK_FLIGHT_WITH_OVERLAY,
  flight: MOCK_FLIGHT_WITHOUT_OVERLAY,
};
export const MOCK_ITINERARY_FLIGHT_PRODUCT_RETURN: ItineraryProduct = {
  id: 7,
  name: 'Vlucht',
  type: 'flight',
  Rate: MOCK_RATE,
  Supplier: MOCK_SUPPLIER,
  selected: true,
  startDate: '2025-05-15',
  startTime: '12:00',
  endDate: '2025-05-15',
  endTime: '14:00',
  sellAmount: 100,
  Content: [],
  // flight: MOCK_FLIGHT_WITH_OVERLAY,
  flight: MOCK_FLIGHT_WITHOUT_OVERLAY2,
};

export const MOCK_PRODUCTS = {
  // accommodations: [MOCK_ITINERARY_ACCOMMODATION_PRODUCT, MOCK_ITINERARY_ACCOMMODATION_PRODUCT_UPGRADE],
  accommodations: [
    MOCK_ITINERARY_ACCOMMODATION_PRODUCT,
    MOCK_ITINERARY_ACCOMMODATION_PRODUCT2,
    MOCK_ITINERARY_ACCOMMODATION_PRODUCT3,
  ],
  excursions: [MOCK_ITINERARY_EXCURSION_PRODUCT, MOCK_ITINERARY_EXCURSION_PRODUCT_UNSELECTED],
  flights: [MOCK_ITINERARY_FLIGHT_PRODUCT],
  carRentals: [MOCK_ITINERARY_RENTAL_CAR_PRODUCT],
};
